<template lang="pug">
	.creative-settings(v-if="showed && creative" v-window)
		.card
			.card-header
				i.fa.fa-edit
				span Creative Settings
				.project-id Creative id: {{creative.id}}
			.card-body.collapse.show
				.form-horizontal
					.form-group.separator
						label.col-form-label Creative title
							.controls
								input.form-control.title(size="16" type="text" v-model="title" @input="updateTitle")
					.form-group(v-if="_.size(publisher.options.projectMarkers) > 0")
						label.col-form-label Creative markers
						.marker-list
							button.creative-marker.btn(:class="{'btn-outline-dark': !_.includes(creative.options.markers, marker), 'btn-primary': _.includes(creative.options.markers, marker)}" type="button" @click="changeCreativeMarker(marker)" v-for="(markerData, marker) in publisher.options.projectMarkers") {{marker}}
					.form-group.form-hide.separator(v-if="_.size(publisher.options.projectMarkers) > 0")
						label Show only in these markers menu
						label.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
							input.switch-input.form-check-input(type="checkbox" :checked="creative.options['showOnlyInMarkersMenu']" @change="saveOption('showOnlyInMarkersMenu', $event.target.checked)")
							span.switch-slider(data-checked="On" data-unchecked="Off")
					.form-group.creatives-access.separator(v-if="User.currentUser.Tags['super-admin']")
						label {{Metadata.Config["dashboard-domain-title"]}} developers access
						.description.text-muted
							span Choose who from {{Metadata.Config["dashboard-domain-title"]}} team will have access to the «{{creative.title}}» creative
						.columns-3
							.column
								.multi-select-checkbox.form-check.checkbox(v-for="user in mraidioDevelopers[0]")
									label.form-check-label
										input.form-check-input(type="checkbox" :checked="user.options?.access?.['projects-full-access'] || user.options?.access?.projects?.[creative.id]" :disabled="user.options?.access?.['projects-full-access']" v-on:change="changeMraidioCreativeAccess(user, $event.target.checked)")
										|{{user.name}}
							.column
								.multi-select-checkbox.form-check.checkbox(v-for="user in mraidioDevelopers[1]")
									label.form-check-label
										input.form-check-input(type="checkbox" :checked="user.options?.access?.['projects-full-access'] || user.options?.access?.projects?.[creative.id]" :disabled="user.options?.access?.['projects-full-access']" v-on:change="changeMraidioCreativeAccess(user, $event.target.checked)")
										|{{user.name}}
							.column
								.multi-select-checkbox.form-check.checkbox(v-for="user in mraidioDevelopers[2]")
									label.form-check-label
										input.form-check-input(type="checkbox" :checked="user.options?.access?.['projects-full-access'] || user.options?.access?.projects?.[creative.id]" :disabled="user.options?.access?.['projects-full-access']" v-on:change="changeMraidioCreativeAccess(user, $event.target.checked)")
										|{{user.name}}
					.progress.add-progress(:style="{display: isUploading ? 'block' : 'none'}")
						.progress-bar.progress-bar-striped.progress-bar-animated(role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" :style="{width: (uploadProgress * 100) + '%'}")
					.form-actions
						button.btn.btn-danger(v-if="canDeleteCreative() && creative" type="button" @click="deleteCreative()" v-b-tooltip.hover.v-danger="{delay: { show: 500, hide: 100 }, title: 'Delete creative'}")
							i.fa.fa-remove
							span Delete
						button.btn.btn-primary(type="button" v-on:click="uploadIcon()")
							i.fa.fa-upload
							span Upload icon
						button.btn.btn-dark(type="button" @click="closeWindow()") Close
</template>

<script>

	import Screen 				from '../../mixins/screen';
	import { Auth } from "../../services/Auth";

	import { Creative } 			from '../../services/Creative';
	import { Version } 			from '../../services/Version';
	import { Settings } 		from '../../services/Settings';

	export default {
		name: "CreativeSettings",
		mixins: [Screen],
		screen: {
			updateOn: [
				"Selected Creative Markers Changed",
				"Selected Creative End Card Markers Changed"
			]
		},
		data() {

			this.Creative = Creative;
			this.Version = Version;
			this.Settings = Settings;

			this.mraidioDevelopers = [[], [], []];

			return {
				title: '',
				isUploading: false,
				uploadProgress: 0
			}
		},
		methods: {
			collectData() {

				if (!Creative.SelectedCreative) return;

				this.creative = Creative.SelectedCreative;
				this.title = this.getCreativeTitle();
				this.publisher = Publisher.getPublisher(this.creative['publisher_id'], Publisher.getSelectedServerId());

				let mraidioDevelopers = _.orderBy(_.filter(User.getUsers(), user => user.active && user.isAdmin), 'id');
				let partLength = Math.ceil(mraidioDevelopers.length / 3);

				this.mraidioDevelopers[0] = mraidioDevelopers.slice(0, partLength);
				this.mraidioDevelopers[1] = mraidioDevelopers.slice(partLength, partLength * 2);
				this.mraidioDevelopers[2] = mraidioDevelopers.slice(partLength * 2);

			},
			updateTitle() {

				Server.sendWithTimeout({
					RenameCreative: {
						creativeId: this.creative.id,
						title: this.title.trim()
					}
				}, null, 200);

			},
			uploadIcon() {

				this.uploadProgress = 0;

				let input = document.createElement('input');
				input.type = 'file';
				input.style.position = 'absolute';
				input.style.left = '0';
				input.style.top = '0';
				input.style.transform = 'scale(0.1)';
				input.style.visibility = 'hidden';
				document.body.appendChild(input);

				input.accept = "image/png, image/jpeg, image/gif";

				input.addEventListener('change', e => {

					this.uploadIconFile(e.target.files[0]);

					document.body.removeChild(input);

				});

				input.addEventListener('blur', e => {

					document.body.removeChild(input);

				});

				input.click();

			},
			uploadIconFile(file) {

				let formData = new FormData();

				formData.append("creativeId", Creative.SelectedCreative.id);
				formData.append("file", file);

				let url = `${location.protocol}//${SetupSettings["domain"]}/creative/updateIcon`;

				let xhr = new XMLHttpRequest();


				xhr.open("POST", url);
				Auth.authorizeRequest(xhr);

				xhr.upload.onprogress = e => {

					if (e.lengthComputable) {

						this.uploadProgress = e.loaded / e.total;

					}

				};

				xhr.upload.onloadstart = e => {

					this.isUploading = true;

				};

				xhr.upload.onloadend = e => {

					this.isUploading = false;

				};

				xhr.send(formData);

			},
			getCreativeTitle() {

				return this.creative?.title || '';

			},
			changeCreativeMarker(creativeMarkerName) {

				if (_.includes(this.creative.options.markers, creativeMarkerName)) {

					Server.sendToServer({
						UnsetCreativeMarker: {
							creativeId: this.creative.id,
							creativeMarkerName: creativeMarkerName
						}
					});

				} else {

					Server.sendToServer({
						SetCreativeMarker: {
							creativeId: this.creative.id,
							creativeMarkerName: creativeMarkerName
						}
					});

				}

			},
			changeMraidioCreativeAccess(user, isChecked) {

				Server.sendToServer({
					UpdateUserCreativeAccess: {
						userId: user.id,
						creativeId: this.creative.id,
						grantAccess: isChecked
					}
				});

			},
			saveOption(optionName, newData) {

				this.creative.options[optionName] = newData;

				Server.sendWithTimeout({
					UpdateCreativeOptions: {
						creativeId: this.creative.id,
						[optionName]: this.creative.options[optionName]
					}
				}, null, 300);

			},
			canDeleteCreative() {

				if (User.currentUser.Tags['admin'] || User.currentUser.Tags['publisher-admin']) return true;

				return (this.publisher && this.publisher.options && this.publisher.options['canDeleteProjects']);

			},
			deleteCreative() {

				Broadcast.call("Pseudo Modal Hide", ['creative-actions-dropdown']);

				Broadcast.call("Show CreativeDelete");

				this.hide();

			}
		}
	}
</script>


<style lang="sass">

	.creative-settings
		display: flex
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.project-id
			position: absolute
			top: 19px
			right: 19px
			opacity: 0.1

		.separator
			padding-bottom: 20px
			border-bottom: 1px solid rgba(0, 0, 0, 0.3)
			margin-bottom: 10px

		.card
			width: 750px
			margin: auto
			display: flex
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			input.title
				width: 400px
				margin-top: 5px

			.btn-danger, .btn-primary
				white-space: nowrap
				margin-right: 20px

				i
					margin-right: 10px

			.btn-ghost-dark, .btn-dark
				float: right
				color: #fff

			.btn-warning
				white-space: nowrap
				margin-right: 20px

			.switch-slider
				background-color: #343b41
				border: 1px solid #23282c

			.progress.add-progress
				height: 5px
				margin-top: 10px
				margin-bottom: 10px

		.form-hide
			display: flex
			flex-direction: row

		.form-group
			display: flex
			flex-direction: column

		.marker-list
			display: flex
			flex-direction: row
			margin-bottom: 0px

			button.creative-marker
				margin-right: 10px

		.multi-select-checkbox
			margin-bottom: 10px
			margin-right: 20px

			label
				margin-bottom: 0
				cursor: pointer

				.form-check-input
					top: -1px

				input
					cursor: pointer

		.form-group.creatives-access
			flex-direction: column
			flex-wrap: nowrap
			padding-bottom: 1rem
			user-select: none

			> .description
				margin-bottom: 20px

			.columns-3
				display: flex
				flex-direction: row
				justify-content: space-between

				.column
					display: flex
					flex-direction: column

		.form-actions
			margin-top: 20px

</style>

